import { HttpErrorResponse } from '@angular/common/http';
import { Constant } from 'src/constant';

export function parsePreviewErrorResponse(error: HttpErrorResponse) {
    switch (error.error.name) {
        case Constant.errorTypes.Email:
            return Constant.errorTypes.Email;
        case Constant.errorTypes.Password:
            return Constant.errorTypes.Password;
        case Constant.errorTypes.AccessorUsageExceeded:
            return Constant.errorTypes.AccessorUsageExceeded;
        case Constant.errorTypes.OwnerUsageExceeded:
            return Constant.errorTypes.OwnerUsageExceeded;
        default:
            return error.error.error;
    }
}
